import { persist } from 'zustand/middleware'
import { AccountHolder, Patient } from '../../types/en-us'
import { PatientDataStore } from './types'
import { create } from 'zustand'

export const usePatientStore = create<PatientDataStore>()(
  persist(
    (set, get) => {
      return {
        patient: null,
        holder: null,
        setPatientData: (patientData: Partial<Patient>) => {
          set({
            patient: {
              ...get().patient,
              ...patientData,
            },
          })
        },
        setHolder: (holder: Partial<AccountHolder>) => {
          set({
            holder: {
              ...get().holder,
              ...holder,
            },
          })
        },
        resetPatientData: () => set({ patient: {} as Patient }),
        resetHolder: () => set({ holder: {} as AccountHolder }),
      }
    },
    {
      name: 'patient',
      getStorage: () => sessionStorage,
    },
  ),
)
